import Axios from "../../configs/axios.config";

export const getManageSalary = (data) =>
  Axios.get(`/payroll/manage-salary`, { params: data }).then(
    (response) => response.data.data
  );
export const getStaffSalary = (data) =>
  Axios.get(`/payroll/salary-report/user`, { params: data }).then(
    (response) => response.data.data
  );

export const updateSalary = (data) =>
  Axios.post(`/payroll/manage-salary/store`, data);

export const getStaffPayrollAttendance = (data) =>
  Axios.get(`/payroll/attendance`, { params: data }).then(
    (response) => response.data.data
  );

export const getStaffPayrollList = (data) =>
  Axios.get(`/payroll/terminate/staff`, { params: data }).then(
    (response) => response.data.data
  );

export const createSalaryReport = (data) =>
  Axios.post(`/payroll/salary-report`, data);

export const getSalaryReport = (data) =>
  Axios.get(`/salary/salary-report/payroll-attendance`, { params: data }).then(
    (response) => response.data
  );

export const getSalaryReportDetails = (id, data) =>
  Axios.get(`/payroll/salary-report/${id}`, { params: data }).then(
    (response) => response.data.data
  );

export const paySalaryByStaff = (id, data) =>
  Axios.put(`/payroll/salary-report/user/${id}`, data).then(
    (response) => response.data.data
  );

export const terminateUser = (data) =>
  Axios.get(`/payroll/terminate/user`, { params: data }).then(
    (response) => response.data.data
  );

export const getSalaryReportStaff = (data) =>
  Axios.get(`payroll/salary-report/auth`, { params: data }).then(
    (response) => response.data.data
  );

export const deleteSalaryReport = (id) =>
  Axios.delete(`/payroll/salary-report/${id}`);

export const deleteSalary = (id) =>
  Axios.delete(`/payroll/salary-report/user/${id}`);
// export const getSalaryReportStaff = (data) =>
//   Axios.get(`payroll/salary-report/auth`, data).then(
//     (response) => response.data.data
//   );

export const paySalaryByAllStaff = ( data) =>
  Axios.put(`/payroll/salary-report/user/all/reports`, data).then(
    (response) => response.data.data
  );

  export const getDownloadPaySlip = (id) => Axios.get(`/payroll/salary-report/download/${id}`).then(response => response.data);



  export const saveEmployeeSalarySetup = (id,data) => Axios.post(`/salary/${id}`, data).then(response => response.data.data);